<template>
  <transition name="transition-logo">
    <commerce-account-description-wrap
      v-show="logoDescIsOpen"
      class="payment-header__logo__description"
      :style="{width: width}"
    >
      <commerce-account-description>
        <div class="payment-header__description__title">{{ checkout.name }}</div>
        <div
          class="payment-header__description__text"
        >{{ checkout.description || $t('empty_data') }}</div>

        <styledWebsiteLink class="payment-header__description__link">
          <a :href="checkout.website" target="_blank">{{ (checkout.website || '').indexOf('https://') != -1 ? checkout.website.split('https://')[1] : ''}}</a>
        </styledWebsiteLink>
      </commerce-account-description>

      <commerce-account-mobile-nav>
        <styled-close-icon>
          {{ $t('close') }}
        </styled-close-icon>
      </commerce-account-mobile-nav>
    </commerce-account-description-wrap>
  </transition>
</template>

<script>
import styled from "vue-styled-components";
import { mapGetters, mapState } from "vuex";


const styledWebsiteLink = styled.section`
  color: ${props => props.theme.primary};
  a {
    color: ${props => props.theme.primary};
  }
`;


const commerceAccountDescriptionWrap = styled.section`
  &.payment-header__logo__description {
    background-color: ${props => props.theme.surface};
    border-radius: ${props => props.theme.border_radius};
    color: ${props => props.theme.on_surface};
    &__title {
      font-weight: 300;
      color: ${props => props.theme.on_surface};
    }
    @media screen and (min-width: 769px) {
      padding: 15px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      &__title {
        font-weight: 300;
        color: ${props => props.theme.on_surface};
      }
    }
  }
`;


const styledCloseIcon = styled.section`
    text-align: center;
    color: ${props => props.theme.primary};
`;

const commerceAccountMobileNav = styled('div', {})`
 display: none;
 @media screen and (max-width: 769px) {
        display: block;
        border-top: 1px solid #d7d8db;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #0055cc;
  }
`;


const commerceAccountDescription = styled.section`
  color: ${props => props.theme.primary_text_color};
  text-align: left;
  font-weight: normal;
  color: ${props => props.theme.on_surface};

  .payment-header__description__title {
    color: ${props => props.theme.on_surface};
  }
  .payment-header__description__text {
    color: ${props => props.theme.on_surface};
  }
  @media screen and (max-width: 769px) {
    padding: 20px;
    font-size: 16px;
    font-weight: normal;
    .payment-header__logo__description {
      &__title {
        font-weight: 300;
      }
    }
  }
`;

export default {
  components: {
    commerceAccountDescriptionWrap,
    commerceAccountDescription,
    commerceAccountMobileNav,
    styledWebsiteLink,
    styledCloseIcon
  },
  props: {
    logoDescIsOpen: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    ...mapState(["commerceAccountData"]),

    checkout() {
      return this.commerceAccountData || {};
    },

    width() {
      if (this.screenSize.width > 768) {
        return "380px";
      } else {
        return `${this.screenSize.width}px`;
      }
    }
  },

};
</script>

